document.addEventListener('DOMContentLoaded', function() {
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowWidth = window.innerWidth;
    
    // IN HOME DESIGN
    const parallaxSection = document.querySelector('.parallax-inHomeDesign');
    if (parallaxSection) {
      const element1 = document.getElementById('Design-element-1');
      const element2 = document.getElementById('Design-element-2');
      
      // Get body height and calculate rotation
      const bodyHeight = document.body.scrollHeight;
      const rotationDegrees = (scrollTop / bodyHeight) * 550;
      
      // Apply rotation to both elements
      if (element1) {
        element1.style.transform = `rotate(${rotationDegrees}deg)`;
      }
      
      if (element2) {
        element2.style.transform = `rotate(${rotationDegrees}deg)`;
      }
      
    }
    
    // MATTRESSES
    const mattressesSection = document.querySelector('.parallax-Mattresses');
    if (mattressesSection) {
      const mattressesSectionRect = mattressesSection.getBoundingClientRect();
      const mattressesSectionTop = mattressesSectionRect.top + scrollTop;
      
      const mattressElement1 = document.getElementById('Mattresses-element-1');
      const mattressElement2 = document.getElementById('Mattresses-element-2');
      const mattressElement3 = document.getElementById('Mattresses-element-3');
      
      if (scrollTop > mattressesSectionTop - 600 && windowWidth >= 360) {
        // Show mattresses elements
        if (mattressElement1) {
          mattressElement1.classList.add('element1');
          mattressElement1.classList.remove('element1_hide');
        }
        
        if (mattressElement2) {
          mattressElement2.classList.add('element2');
          mattressElement2.classList.remove('element2_hide');
        }
        
        if (mattressElement3) {
          mattressElement3.classList.add('element3');
          mattressElement3.classList.remove('element3_hide');
        }
      } else {
        // Hide mattresses elements
        if (mattressElement1) {
          mattressElement1.classList.remove('element1');
          mattressElement1.classList.add('element1_hide');
        }
        
        if (mattressElement2) {
          mattressElement2.classList.remove('element2');
          mattressElement2.classList.add('element2_hide');
        }
        
        if (mattressElement3) {
          mattressElement3.classList.remove('element3');
          mattressElement3.classList.add('element3_hide');
        }
      }
    }
    
    // STRESSLESS
    const stresslessSection = document.querySelector('.parallax-Stressless');
    if (stresslessSection) {
      const stresslessSectionRect = stresslessSection.getBoundingClientRect();
      const stresslessSectionTop = stresslessSectionRect.top + scrollTop;
      
      const stresslessElement1 = document.getElementById('Stressless-element-1');
      
      if (scrollTop > stresslessSectionTop - 500 && windowWidth >= 1200) {
        // Show stressless element
        if (stresslessElement1) {
          stresslessElement1.classList.add('element1');
          stresslessElement1.classList.remove('element1_hide');
        }
      } else {
        // Hide stressless element
        if (stresslessElement1) {
          stresslessElement1.classList.remove('element1');
          stresslessElement1.classList.add('element1_hide');
        }
      }
    }
    
    // FLOORING
    const flooringSection = document.querySelector('.parallax-Flooring');
    if (flooringSection) {
      const flooringSectionRect = flooringSection.getBoundingClientRect();
      const flooringSectionTop = flooringSectionRect.top + scrollTop;
      
      const flooringElement1 = document.getElementById('Flooring-element-1');
      const flooringElement2 = document.getElementById('Flooring-element-2');
      const flooringElement3 = document.getElementById('Flooring-element-3');
      const flooringElement4 = document.getElementById('Flooring-element-4');
      
      if (windowWidth >= 1200 && scrollTop > flooringSectionTop - 500) {
        // Show flooring elements
        if (flooringElement1) {
          flooringElement1.classList.add('element1');
          flooringElement1.classList.remove('element1_hide');
        }
        
        if (flooringElement2) {
          flooringElement2.classList.add('element2');
          flooringElement2.classList.remove('element2_hide');
        }
        
        if (flooringElement3) {
          flooringElement3.classList.add('element3');
          flooringElement3.classList.remove('element3_hide');
        }
        
        if (flooringElement4) {
          flooringElement4.classList.add('element4');
          flooringElement4.classList.remove('element4_hide');
        }
      } else {
        // Hide flooring elements
        if (flooringElement1) {
          flooringElement1.classList.remove('element1');
          flooringElement1.classList.add('element1_hide');
        }
        
        if (flooringElement2) {
          flooringElement2.classList.remove('element2');
          flooringElement2.classList.add('element2_hide');
        }
        
        if (flooringElement3) {
          flooringElement3.classList.remove('element3');
          flooringElement3.classList.add('element3_hide');
        }
        
        if (flooringElement4) {
          flooringElement4.classList.remove('element4');
          flooringElement4.classList.add('element4_hide');
        }
      }
    }
  }
  
  // Add scroll event listener with throttling for better performance
  let ticking = false;
  
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }
  
  function onScroll() {
    requestTick();
    ticking = false;
  }
  
  // Attach scroll event listener
  window.addEventListener('scroll', onScroll);
  
  // Run once on load to set initial state
  handleScroll();
  
  // SIGN-IN PAGE AUTOSCROLL
  const autoscrollSection = document.querySelector('.parallax-Autoscroll');
  if (autoscrollSection && document.documentElement.clientWidth > 1280) {
    const computedStyle = window.getComputedStyle(autoscrollSection);
    const backgroundImage = computedStyle.backgroundImage;

    // Extract image URL from background-image CSS property
    const imageUrl = backgroundImage.match(/^url\("?(.+?)"?\)$/);

    if (imageUrl) {
      const img = new Image();
      img.onload = function() {
        const bgImgHeight = img.height;
        autoscrollSection.style.backgroundPositionY = bgImgHeight + 'px';

        let currentPosY = bgImgHeight;
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        const speed = 0.1 * pixelRatio; // Adjust speed based on pixel ratio

        function animateBackground() {
          currentPosY = parseFloat(autoscrollSection.style.backgroundPositionY) || bgImgHeight;
          if (currentPosY > 0) {
            currentPosY -= speed;
          } else {
            currentPosY = bgImgHeight;
          }
          autoscrollSection.style.backgroundPositionY = currentPosY + 'px';
          requestAnimationFrame(animateBackground);
        }
        requestAnimationFrame(animateBackground);
      };
      img.src = imageUrl[1];
    }
  }
})